export const getSystemInfo = () => ({
    isApp: false,
    platform: "web",
    version: "0.0.0",
})

export const getPageInfo = () => ({
    safeArea: { top: 0, bottom: 0, left: 0, right: 0 },
})

export const checkInSklandApp = () => false

export const pop = () => {}

export const shareImage = async () => {}

export const getDeviceId = async () => "mock-device-id"

const skland = {
    getSystemInfo,
    getPageInfo,
    checkInSklandApp,
    pop,
    shareImage,
    getDeviceId,
}

export default skland
